import './TagPill.css';
import { ArrowIcon } from '../../assets/ArrowIcon';

interface TagPillProps {
  tagName: string;
  values: string[];
  onPress: () => void;
}

export function TagPill({ tagName, values, onPress }: TagPillProps) {
  const hasValues = values.length > 0;
  const displayText = hasValues
    ? `${tagName}: ${values.join(', ')}`
    : tagName;

  return (
    <button
      type="button"
      className={`tag-pill ${!hasValues ? 'tag-pill--empty' : ''}`}
      onClick={onPress}
    >
      <span className="tag-pill__text">{displayText}</span>
      <ArrowIcon className="tag-pill__chevron" />
    </button>
  );
}
